import { CreateKeyValueRequest } from "@models/base/createKeyValueRequest.model"

export class CreatePermisoRequest extends CreateKeyValueRequest {
  public token!: string
  public idCasoUso!: number
  public idRol!: number
}
